import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { setTestDriveSlotAction } from "@redux/actions/testDriveActions";

export const useTestDriveLocationHandler = (target, selectedTarget) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      target?.id !== selectedTarget?.id ||
      target?.type !== selectedTarget?.type
    ) {
      dispatch(setTestDriveSlotAction(null));
    }
  }, []);
};
